import {
  CommonModule,
  isPlatformServer,
  registerLocaleData,
} from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import * as localeIt from '@angular/common/locales/it';
import {
  inject,
  NgModule,
  PLATFORM_ID,
  provideAppInitializer,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { CookieInterceptor } from '@shared/interceptors/cookie.interceptor';
import { SharedModule } from '@shared/shared.module';
import { of } from 'rxjs';
import { LoginModule } from '../login/login.module';
import { initializeCoreFactory } from './initializer/core.initializer';
import { CustomExceptionInterceptor } from './interceptors/custom-exception.interceptor';
import { AuctionService } from './services/auction.service';

registerLocaleData(localeIt.default || localeIt);

// AoT requires an exported function for factories
export function HttpLoaderFactory() {
  return new TranslateHttpLoader();
}

@NgModule({
  declarations: [],
  exports: [],
  imports: [
    CommonModule,
    RouterModule,
    FontAwesomeModule,
    SharedModule,
    TranslateModule,
    FormsModule,
    LoginModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      multi: true,
      useClass: CookieInterceptor,
    },
    {
      provide: HTTP_INTERCEPTORS,
      multi: true,
      useClass: AuthInterceptor,
    },
    {
      provide: HTTP_INTERCEPTORS,
      multi: true,
      useClass: CustomExceptionInterceptor,
    },
    {
      provide: HTTP_INTERCEPTORS,
      multi: true,
      useClass: ErrorInterceptor,
    },
    provideAppInitializer(() => {
      const initializerFn = initializeCoreFactory(inject(AuctionService));
      return initializerFn();
    }),
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class CoreModule {}
